import { useQuery } from '@tanstack/react-query';

import { getFlexConfig } from '../../lib/api/endpoints';

export const flexKeys = {
  all: ['flex'] as const,
  config: (accountId: string | null) => ['flex', 'config', accountId] as const,
};

export function useFlexConfig(accountId: string | null) {
  return useQuery({
    queryKey: flexKeys.config(accountId),
    queryFn: () => {
      if (!accountId) throw new Error('Account id is required.');
      return getFlexConfig(accountId);
    },
    enabled: Boolean(accountId),
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
  });
}
